<div class="content">
  <div class="head-wrapper">
    <div class="left">
      <h4 class="ng-binding header">CREATE DOCUMENT</h4>
      <p class="ng-binding" style="margin: 4px; font-size: 14px;color: #666;">Select a business area and document type. When the
        indexing fields are completed select a document to upload, then click the Submit button.</p>
    </div>
  </div>
  <div *ngIf="isLoading" class="global-loading-overlay">
    <div class="global-loading-spinner">
      <mat-spinner diameter="80"></mat-spinner>
    </div>
  </div>
  <mat-accordion> 
    <mat-expansion-panel>
      <mat-expansion-panel-header style="height: 32px;">
        <mat-panel-title>
          <h2 mat-dialog-title class="dialog-header">
            <div class="header-left" style="font-size: 13px !important;">
              <mat-icon class="header-icon">description</mat-icon>
              BUSINESS AREA AND DOCUMENT TYPE
            </div>
          </h2>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div class="row"> 
        <div class="col-sm-6 form-field-wrapper">
          <label style="font-weight: 500;" class="form-label">Business Area</label>
          <mat-form-field class="mat-select-header" appearance="fill">
            <mat-select [(value)]="selectedBusinessArea" name="businessArea" placeholder="Select Business Area"
              (selectionChange)="getDocumentTypesBasedOnBusinessArea($event)">
              <ng-container *ngIf="!isBALoading; else loadingTemplate">
                <mat-option [value]="null">Select Business Area</mat-option>
                <mat-option *ngFor="let area of businessAreaList" [value]="area.id">{{ area.name }}</mat-option>
              </ng-container>
              <ng-template #loadingTemplate>
                <mat-option disabled>
                  <mat-spinner diameter="20"></mat-spinner>
                </mat-option>
              </ng-template>
            </mat-select>
          </mat-form-field>
        </div>
 
        <div class="col-sm-6 form-field-wrapper" *ngIf="selectedBusinessArea">
          <label style="font-weight: 500;" class="form-label">Document Type</label>
          <mat-form-field class="mat-select-header" appearance="fill">
            <mat-select [(value)]="selectedDocumentType" name="documentType" placeholder="Select Document Type"
              (selectionChange)="getIndexFieldsBasedOnDocumentType($event)">
              <ng-container *ngIf="!isDocTypeLoading; else loadingTemplate">
                <mat-option [value]="">Select Document Type</mat-option>
                <mat-option *ngFor="let docType of documentTypes" [value]="docType.id">{{docType.name}}</mat-option>
              </ng-container>
              <ng-template #loadingTemplate>
                <mat-option disabled>
                  <mat-spinner diameter="20"></mat-spinner>
                </mat-option>
              </ng-template>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </mat-expansion-panel>
 
    <mat-expansion-panel #indexingFieldsPanel>
      <mat-expansion-panel-header style="height: 32px;">
        <mat-panel-title>
          <h2 mat-dialog-title class="dialog-header">
            <div class="header-left" style="font-size: 13px !important;">
              <mat-icon class="header-icon">calendar_month</mat-icon>
              INDEXING FIELDS
            </div>
          </h2>
        </mat-panel-title>
      </mat-expansion-panel-header> 

      <form [formGroup]="form">
        <div formArrayName="indexingFields">
          <div class="row" style="padding: 15px;">
            <ng-container *ngIf="!isIndexFieldsLoading">
              <ng-container *ngFor="let field of indexingFields.controls; let i = index">
                <div class="col-sm-3" [formGroupName]="i" *ngIf="!field.get('isSystemField')?.value  && field.get('controlType')?.value !== 1">
                  <div class="index-field-wrapper">
                  <!-- DATE FIELD -->
                  <ng-container *ngIf="field.get('controlType')?.value === 5 || field.get('controlName')?.value === 'DATE'">
                    <label class="form-label">
                      <span *ngIf="field.get('isMandatory')?.value" class="required-asterisk">*</span>
                      {{ field.get('displayName')?.value }}
                    </label>
                    <mat-form-field appearance="fill">
                      <input matInput [matDatepicker]="picker" formControlName="valueAsString" [placeholder]="getDatePlaceholder(i)"
                        [required]="field.get('isMandatory')?.value" [readonly]="field.get('isReadOnly')?.value"
                        [attr.aria-describedby]="'error-' + field.get('columnName')?.value"
                        (dateChange)="onDateChange($event, i)" (blur)="onDatepickerOpened(i)">
                      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                      <mat-datepicker #picker></mat-datepicker>
                      <mat-error *ngIf="field.get('valueAsString')?.invalid && (field.get('valueAsString')?.dirty || field.get('valueAsString')?.touched)"
                        id="error-{{ field.get('columnName')?.value }}">
                        <span *ngIf="field.get('valueAsString')?.errors?.['required']">
                          {{ field.get('displayName')?.value }} is required.
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </ng-container>

                  <!-- CHECKBOX FIELD -->
                  <ng-container *ngIf="field.get('controlType')?.value === 2 || field.get('controlName')?.value === 'CHECK_BOX'">
                    <mat-checkbox formControlName="valueAsString" [required]="field.get('isMandatory')?.value"
                      [attr.aria-describedby]="'error-' + field.get('columnName')?.value">
                      <span *ngIf="field.get('isMandatory')?.value" class="required-asterisk">*</span>
                      {{ field.get('displayName')?.value }}
                    </mat-checkbox>
                    <mat-error *ngIf="field.get('valueAsString')?.invalid && (field.get('valueAsString')?.dirty || field.get('valueAsString')?.touched)"
                      id="error-{{ field.get('columnName')?.value }}">
                      <span *ngIf="field.get('valueAsString')?.errors?.['required']">
                        {{ field.get('displayName')?.value }} is required.
                      </span>
                    </mat-error>
                  </ng-container>

                  <!-- COMBO BOX -->
                  <ng-container *ngIf="field.get('controlType')?.value === 3 || field.get('controlName')?.value === 'COMBO_BOX'">
                    <label class="form-label">
                      <span *ngIf="field.get('isMandatory')?.value" class="required-asterisk">*</span>
                      {{ field.get('displayName')?.value }}
                    </label>
                    <mat-form-field appearance="fill">
                      <mat-select placeholder="Select a value" formControlName="valueAsString"
                        [required]="field.get('isMandatory')?.value"
                        [attr.aria-describedby]="'error-' + field.get('columnName')?.value" placeholder="Select a value">
                        <mat-option [value]="''">Select a value</mat-option>
                        <mat-option *ngFor="let option of field.get('comboValues')?.value" [value]="option.fieldId">
                          {{ option.comboValue }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngIf="field.get('valueAsString')?.invalid && (field.get('valueAsString')?.dirty || field.get('valueAsString')?.touched)"
                        id="error-{{ field.get('columnName')?.value }}">
                        <span *ngIf="field.get('valueAsString')?.errors?.['required']">
                          {{ field.get('displayName')?.value }} is required.
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </ng-container>

                  <!-- TEXT BOX -->
                  <ng-container *ngIf="field.get('controlType')?.value === 4 || field.get('controlName')?.value === 'TEXT_BOX'">
                    <label class="form-label">
                      <span *ngIf="field.get('isMandatory')?.value" class="required-asterisk">*</span>
                      {{ field.get('displayName')?.value }}
                    </label>
                    <mat-form-field appearance="fill">
                      <input matInput type="text" formControlName="valueAsString"
                        placeholder="Enter {{ field.get('displayName')?.value }}"
                        [required]="field.get('isMandatory')?.value" [maxlength]="field.get('fieldLength')?.value"
                        [attr.aria-describedby]="'error-' + field.get('columnName')?.value">
                      <mat-error
                        *ngIf="field.get('valueAsString')?.invalid && (field.get('valueAsString')?.dirty || field.get('valueAsString')?.touched)"
                        id="error-{{ field.get('columnName')?.value }}">
                        <span *ngIf="field.get('valueAsString')?.errors?.['required']">
                          {{ field.get('displayName')?.value }} is required.
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </ng-container>
                </div> <!-- end of index-field-wrapper -->
              </div>
            </ng-container>
            </ng-container>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
 
    <mat-expansion-panel>
      <mat-expansion-panel-header style="height: 32px;">
        <div class="row">
          <mat-panel-title>
            <h2 mat-dialog-title class="dialog-header">
              <div class="header-left" style="font-size: 13px !important;">
                <mat-icon class="header-icon">upload</mat-icon>
                SELECT FILE TO UPLOAD
              </div>
            </h2>
          </mat-panel-title>
        </div>
      </mat-expansion-panel-header>

      <div>
        <div class="row" style="padding: 15px 15px 15px 0px; align-items: center;">
          <div class="col-sm-3" style="width: 100%;"> 
            <span style="font-weight: 500;margin-right: 10px;">Select file to upload </span>
            <input id="fileInput" style="display: none;" required="true" type="file" multiple
              (change)="onFilesSelected($event)" [accept]="allowedFileTypes.join(',')" />
            <label aria-disabled="isFileCountExceeded" for="fileInput"
              class="btn browse browse-file custom-file-upload"> Browse</label>
            <div class="note text-muted small" style="margin-top: 10px;" *ngIf="allowedFileTypes?.length">
              *Note: Only the file types [{{ getReadableFileTypes() }}] can be selected for upload
            </div>
          </div>
        </div>

        <div>
          <div class="drop-zone" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
            <p>Drag & Drop files here</p>
          </div>
        </div>

        <div>
          <div class="file-list" style="padding: 15px 15px 15px 0px; max-width: fit-content;">
            <div *ngFor="let file of files;let i = index">
              <div class="file-item">{{ file.name }}
                <span class="material-icons close-icon" role="button" tabindex="0" (click)="removeFile(i)" (keydown.enter)="removeFile(i)" (keydown.space)="removeFile(i); $event.preventDefault()"> close
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="mt-3">
          <div *ngIf="uploadLimitFailure" class="text-danger">
            Error: You can upload up to {{ maxFilesLimit }} files only.
          </div>
          <div *ngIf="invalidFileTypes?.length" class="text-danger">
            Invalid file type(s): {{ invalidFileTypes.join(', ') }}
          </div>
          <div *ngIf="oversizedFiles?.length" class="text-danger">
            File(s) exceeding {{ maxFileSizeMB }} MB: {{ oversizedFiles.join(', ') }}
          </div>
          <div *ngIf="duplicateFiles?.length" class="text-danger">
            File(s) already attached: {{ duplicateFiles.join(', ') }}
          </div>
        </div>
      </div>
    </mat-expansion-panel>
     
    <mat-expansion-panel>
      <mat-expansion-panel-header style="height: 32px;">
        <mat-panel-title>
          <h2 mat-dialog-title class="dialog-header">
            <div class="header-left" style="font-size: 13px !important;">
              <mat-icon class="header-icon">view_list</mat-icon>
              UPLOAD OPTIONS
            </div>
          </h2>
        </mat-panel-title>
      </mat-expansion-panel-header>

      <div style="padding-top: 15px; padding-bottom: 5px;">
        <div class="row">
          <div *ngIf="hasStartingQueueOptions" class="col-sm-3">
            <mat-checkbox name="workflow" id="workflow" [(ngModel)]="sendToWorkflow"
              [disabled]="!isSendToWorkFlowEnabled || !webUploadIndexFields?.defaultStartingQueue">
              Send to Workflow
            </mat-checkbox>
          </div>
          <div class="col-sm-3">
            <mat-checkbox name="notify" id="notify" [(ngModel)]="sendToNotification"
              [disabled]="!isSendToNotificationEnabled">
              Send Notification Email
            </mat-checkbox>
          </div>
        </div>
        <div *ngIf="sendToWorkflow" class="bg-white">
          <div>
            <div class="row align-items-center" style="padding: 14px;">
              <label class="col-sm-3 col-form-label" for="startQueue" style="font-size: 14px;">
                Select queue to start document
              </label>
              <div class="col-sm-3">
                <mat-form-field appearance="fill" style="width: 100%;">
                  <mat-select id="startQueue" [(value)]="selectedstartQueueId" name="documentQueue" placeholder="Select a Queue">
                    <mat-option [value]="''">Select a Queue</mat-option>
                    <mat-option *ngFor="let queue of documentQueue" [value]="queue.queueId">
                      {{ queue.queueName }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-3">
              <mat-radio-group name="batch" [(ngModel)]="enabledBatch">
                <mat-radio-button value="exist" [disabled]="!isAddtoExistingBatchEnabled">
                  Add to Existing batch
                </mat-radio-button>
              </mat-radio-group>
            </div>
            <div class="col-sm-3">
              <mat-radio-group name="batch" [(ngModel)]="enabledBatch">
                <mat-radio-button value="add">
                  Add to new batch
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        </div>
      </div>
    </mat-expansion-panel>
    
    <div class="row form-buttons">
      <div class="col-sm-6">
        <button mat-stroked-button class="reset" type="button" (click)="resetAll()">Reset</button>
      </div>
      <div class="col-sm-6 text-end">
        <button mat-raised-button class="submit" (click)="submitCombinedForms()"
          [disabled]="!form.valid || files.length === 0">Submit</button>
      </div>
    </div>
  </mat-accordion>
</div>